import { Link } from "react-router-dom";
import useTable from "../../../../MainComponents/Hooks/useTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useAuthState } from "../../../../MainComponents/GlobalContext";
import HelmetTags from "../../../../MainComponents/HelmetTags";

function Assistants() {
  const AuthState = useAuthState();

  const table = useTable("assistants");

  return (
    <section className="dark:bg-dark dark:text-light h-full w-full overflow-y-auto px-10 py-10 sm:px-4">
      <HelmetTags title=" Assistants | Mr Mohamed Salama" />
      <div className="mb-20 flex flex-col items-start gap-20">
        {" "}
        {/* Changed `items-end` to `items-start` */}
        <h2 className="mb-7 text-start text-2xl font-bold sm:text-center">
          Assistants
        </h2>
        {/* Reversed the condition to render the link from left to right */}
        {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
          AuthState.userData?.admin?.permissions?.some((permission) =>
            permission.name.startsWith("user_add")
          )) && (
          <Link
            to="/admin/assistants/add-assistant"
            className="text-white ml-4 rounded-xl border-2 border-secondary bg-secondary px-2 py-1 font-semibold text-light transition-all duration-300 hover:bg-white hover:text-secondary active:scale-90"
          >
            <FontAwesomeIcon className="mr-4" icon={faPlus} />
            Add Assistant
          </Link>
        )}
      </div>
      {/* Removed unnecessary comment */}
      <div className="h-fit w-full">{table}</div>
    </section>
  );
}

export default Assistants;
